import React from 'react';
import { Zap } from 'lucide-react';

const LightningLotIndicator = ({ lot }) => {
  if (lot.status !== 'lightning') return null;
  
  return (
    <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center">
      <Zap className="w-5 h-5 text-amber-500 mr-2" />
      <div>
        <h3 className="font-medium text-amber-800">Lote Relámpago</h3>
        <p className="text-sm text-amber-700">
          Este lote se creó automáticamente durante una venta y necesita reconciliación.
        </p>
      </div>
    </div>
  );
};

export default LightningLotIndicator; 